import React from "react"

const SearchProgressive = () => {
  return (
    <div className="search-result">
      <div className="container-fluid">
        <div className="row no-gutters">
          <div className="col-12 ">
            <div className="search-result__tab-header">
              <div className="container search-result__tab-buttons">
                <button
                  className="search-result__tab-button gbh-data-layer"
                  aria-label="Loading search results"
                >
                  <p className="shimmer-loading__button shimmer"></p>
                </button>
                <button
                  className="search-result__tab-button gbh-data-layer"
                  aria-label="Loading search results"
                >
                  <p className="shimmer-loading__button shimmer"></p>
                </button>
                <button
                  className="search-result__tab-button gbh-data-layer"
                  aria-label="Loading search results"
                >
                  <p className="shimmer-loading__button shimmer"></p>
                </button>
                <button
                  className="search-result__tab-button gbh-data-layer"
                  aria-label="Loading search results"
                >
                  <p className="shimmer-loading__button shimmer"></p>
                </button>
              </div>
            </div>
            <div className="search-result__tab-content">
              <div className="container product-list__container product-list__tiles">
                <div className="row">
                  <div className="col">
                    <div>
                      <div className="product-list__filter borderNone">
                        <div>
                          <div>
                            <div className="filter__inner-container shimmer height-300"></div>
                            <div className="filter__footer">
                              <div className="products-per-page width-240 mt60 mb20">
                                <p className="shimmer-loading__headpara shimmer"></p>
                              </div>
                              <div className="products-per-page width-100">
                                <p className="shimmer-loading__para shimmer"></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="product-list__tile-col">
                        <div className="row row-cols-3">
                          <div className="col px-1 product-list__tile">
                            <div className="kf-lazyload-wrapper ">
                              <a>
                                <div className="product-tile">
                                  <div className="product-tile__image">
                                    <div className="shimmer-loading__image shimmer"></div>
                                  </div>
                                  <div className="product-tile__details">
                                    <div className="width-full">
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                    </div>
                                    <div className="width-full">
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                    </div>
                                  </div>
                                  <div className="product-tile__details product-tile__compare-main">
                                    <div className="product-tile__colors">
                                      <div className="product-tile__colors--count d-none d-lg-block">
                                        <p className="shimmer-loading__para shimmer width-full"></p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </div>
                          </div>
                          <div className="col px-1 product-list__tile">
                            <div className="kf-lazyload-wrapper ">
                              <a>
                                <div className="product-tile">
                                  <div className="product-tile__image">
                                    <div className="shimmer-loading__image shimmer"></div>
                                  </div>
                                  <div className="product-tile__details">
                                    <div className="width-full">
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                    </div>
                                    <div className="width-full">
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                    </div>
                                  </div>
                                  <div className="product-tile__details product-tile__compare-main">
                                    <div className="product-tile__colors">
                                      <div className="product-tile__colors--count d-none d-lg-block">
                                        <p className="shimmer-loading__para shimmer width-full"></p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </div>
                          </div>
                          <div className="col px-1 product-list__tile">
                            <div className="kf-lazyload-wrapper ">
                              <a>
                                <div className="product-tile">
                                  <div className="product-tile__image">
                                    <div className="shimmer-loading__image shimmer"></div>
                                  </div>
                                  <div className="product-tile__details">
                                    <div className="width-full">
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                    </div>
                                    <div className="width-full">
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                      <p className="shimmer-loading__para shimmer width-full"></p>
                                    </div>
                                  </div>
                                  <div className="product-tile__details product-tile__compare-main">
                                    <div className="product-tile__colors">
                                      <div className="product-tile__colors--count d-none d-lg-block">
                                        <p className="shimmer-loading__para shimmer width-full"></p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchProgressive
